<template>
  <div class="route-container">
    <!-- 左侧菜单组列表 -->
    <div class="left-tree">
      <el-card class="list-selector">
        <ul class="list-selector-list">
          <li @click="handleApp('')"
            :class="{ 'selected': searchForm.appId === '' }">
            {{ $t('common.all') }}
          </li>
          <li v-for="item in apps" :key="item.appId" 
            @click="handleApp(item.appId)"
            :class="{ 'selected': searchForm.appId === item.appId }">
            {{ item.name }}
          </li>
        </ul>
      </el-card>
    </div>

    <!-- 右侧菜单列表 -->
    <div class="menu-list-wrapper">
      <!-- 查询条件 -->
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <span>{{ $t('serviceRegisterManage.queryCondition') }}</span>
        </div>
        <el-form :inline="true" class="demo-form-inline text-left">
          <el-form-item>
            <el-input v-model="searchForm.serviceCode" :placeholder="$t('serviceRegisterManage.serviceCode')"
              clearable @keyup.enter.native="handleSearch" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.serviceName" :placeholder="$t('serviceRegisterManage.serviceName')"
              clearable @keyup.enter.native="handleSearch" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 表格列表 -->
      <el-card style="margin-top: 20px;">
        <div slot="header" class="clearfix flex justify-between">
          <span>{{ $t('serviceRegisterManage.serviceBinding') }}</span>
          <el-button type="primary" @click="handleAdd" v-if="searchForm.appId">
            {{ $t('common.register') }}
          </el-button>
        </div>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
          <el-table-column prop="appId" :label="$t('serviceRegisterManage.appId')" />
          <el-table-column prop="appName" :label="$t('serviceRegisterManage.appName')" />
          <el-table-column prop="serviceId" :label="$t('serviceRegisterManage.serviceId')" />
          <el-table-column prop="serviceName" :label="$t('serviceRegisterManage.serviceName')" />
          <el-table-column prop="serviceCode" :label="$t('serviceRegisterManage.serviceCode')" />
          <el-table-column prop="orderTypeCd" :label="$t('serviceRegisterManage.orderType')" />
          <el-table-column :label="$t('common.operation')" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)">{{ $t('common.delete')
                }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
          :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </el-card>
    </div>

    <DelRoute :visible.sync="delVisible" :route-id="currentRow.id" @success="handleSuccess" />
  </div>
</template>

<script>
import { getRouteList } from '@/api/dev/routeApi'
import { listApps } from '@/api/dev/appApi'

import DelRoute from '@/components/dev/DelRoute'

export default {
  name: 'routeList',
  components: {
    DelRoute
  },
  data() {
    return {
      loading: false,
      apps: [],
      searchForm: {
        appId: '',
        serviceName: '',
        serviceCode: '',
      },
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      addVisible: false,
      editVisible: false,
      delVisible: false,
      currentRow: {}
    }
  },
  created() {
    this.getApps()

  },
  methods: {
    async getApps() {
      try {
        this.loading = true
        const params = {
          page: 1,
          row: 100,
        }
        const { data:apps } = await listApps(params)
        this.apps = apps
        // 默认不选择任何应用，显示"全部应用"
        this.searchForm.appId = ''
      } catch (error) {
        this.$message.error(this.$t('app.fetchError'))
      } finally {
        this.loading = false
      }
    },

    async getList() {
      // 如果没有选择应用，不加载数据
      if (!this.searchForm.appId) {
        this.tableData = []
        this.page.total = 0
        return
      }

      try {
        this.loading = true
        const params = {
          page: this.page.current,
          row: this.page.size,
          appId: this.searchForm.appId,
          serviceId: this.searchForm.serviceId,
          orderTypeCd: this.searchForm.orderTypeCd,
        }
        const { data, total } = await getRouteList(params)
        this.tableData = data
        this.page.total = total
      } catch (error) {
        this.$message.error(this.$t('route.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.getList()
    },
    handleAdd() {
      this.$router.push('/pages/dev/addRoute?appId=' + this.searchForm.appId)
    },
    handleEdit(row) {
      this.currentRow = { ...row }
      this.editVisible = true
    },
    handleDelete(row) {
      this.currentRow = { ...row }
      this.delVisible = true
    },
    handleSuccess() {
      this.getList()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    handleApp(appId) {
      this.searchForm.appId = appId
      if (appId) {
        this.getList()
      } else {
        // 如果选择"全部应用"，清空表格数据
        this.tableData = []
        this.page.total = 0
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.route-container {
  display: flex;
  background-color: #f0f2f5;

  .left-tree {
    width: 200px;
    padding-right: 0;
  }

  .menu-list-wrapper {
    flex: 1;
    padding-left: 10px;
    overflow-y: auto;

    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>